<template>
  <div class="content-panel">
    <div class="filter-inline-panel cle">
      <el-form :inline="true" :model="filterForm" class="filter-panel">
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="add('')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <div>
      <el-table :data="list" size="mini" border row-key="id" :default-expand-all="false">
        <el-table-column :prop="lang=='cn'?'name_cn':'name'" label="名称"></el-table-column>
        <el-table-column prop="sort" align="center" :label="$t('index.sort')"></el-table-column>
        <el-table-column prop="ioc" align="center" :label="$t('system_menu.icon')">
          <template slot-scope="scope">
            <i :class="scope.row.ioc" class="iocnfont"></i>
          </template>
        </el-table-column>
        <el-table-column prop="url" align="center" :label="$t('system_menu.link')"></el-table-column>
        <el-table-column :label="$t('index.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
            <el-button size="mini" type="info" @click="del(scope.row)">{{$t('index.del')}}</el-button>
            <!-- <el-button size="mini" type="primary"><router-link :to="{path:'/system_menu_list',query: {id:scope.row.id}}">{{$t('system_menu.secondary_menu')}}</router-link></el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="900px">
      <el-form label-width="60px" ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('system_menu.name')" prop="name_cn">
              <el-input v-model="editForm.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('system_menu.name')" prop="name">
              <el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('system_menu.link')" prop="url">
              <el-input v-model="editForm.url" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级" prop="parent_id">
            	<el-cascader v-model="editForm.parent_id" clearable class="w100" :options="list" :props="props"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('system_menu.icon')" prop="ioc">
              <el-input v-model="editForm.ioc" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.sort')" prop="sort">
              <el-input v-model="editForm.sort" :placeholder="$t('index.pleaseInput')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed: {
		editFormRules(){
			return{
				name: [{
					required: true,
					message: this.$t('index.input')+this.$t('index.en')+this.$t('system_menu.name'),
					trigger: 'blur'
				}, ],
				name_cn: [{
					required: true,
					message: this.$t('index.input')+this.$t('index.cn')+this.$t('system_menu.name'),
					trigger: 'blur'
				}, ],
				url: [{
					required: true,
					message:this.$t('index.input')+this.$t('system_menu.link'),
					trigger: 'blur'
				}, ],
				ioc: [{
					required: true,
					message:this.$t('index.input')+this.$t('system_menu.icon'),
					trigger: 'blur'
				}, ],
			}
		},
		props(){
			return{
				label:this.lang=='cn'?'name_cn':'name',
				value:'id',
				checkStrictly:true,
			}
		},
	},
	data() {
		return {
			filterForm: {},
			list: [],
			editForm: {},
			editFormVisible: false,
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init: function () {
			var this_ = this;
			var url = "menuTreeList"
			var datas = {}
			this_.$post(url, datas).then((res) => {
				this_.list = res;
			})
		},
		add(data){
			if (data) {
				this.editForm=JSON.parse(JSON.stringify(data));
			}else{
				this.editForm={
					name:'',
					name_cn:'',
					url:'',
					ioc:'',
					sort:'',
					parent_id:'',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible=true;
		},
		editSubmit(){
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var parent_id = 0;
					if (typeof this_.editForm.parent_id == 'number') {
						parent_id = this_.editForm.parent_id;
					} else if (this_.editForm.parent_id.length > 1) {
						parent_id = this_.editForm.parent_id.pop()
					} else if (this_.editForm.parent_id.length === 1) {
						parent_id = this_.editForm.parent_id.toString()
					} else if (this_.editForm.parent_id.length === 0) {
						parent_id = 0
					}
					var url = "menuTreeAction";
					var datas={
						name_cn:this_.editForm.name_cn,
						name:this_.editForm.name,
						url:this_.editForm.url,
						ioc:this_.editForm.ioc,
						sort:this_.editForm.sort,
						parent_id:parent_id,
					}
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}
			})
		},
		del(data){
			var this_ = this;
			var url = "menuTreeDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 18px;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
/* .content-panel {
	min-height: calc(100vh - 252px);
	background: #ffffff;
	padding: 25px 30px;
} */
.content-panel .page-pagination {
	padding: 25px 10px;
	text-align: right;
}
.content-panel .page-pagination .filter-inline-panel {
	margin-bottom: 25px;
}
.content-panel .page-pagination .filter-inline-panel .add-data-base .el-select {
	width: 100%;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.dialog-bottom-btn {
	text-align: center;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
.col_bai:hover,
.col_bai{
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/system/menu.vue